import { AbstractControl } from "@angular/forms";

export function updateValueOnFormChange(params: any, key: string) {
  return (control: AbstractControl) => {
    params[key] = control.value;
    return null;
  };
}
